<template>
  <img
    :src="parsedSrc"
    :loading="loading"
    v-bind="$attrs"

  />
</template>

<script setup lang="ts">

const props = withDefaults(defineProps<{
  src: string,
  loading: string,
}>(), {
  loading: 'lazy',
});
const IMG_PREFIX = /^\/static-file(\/resources)?/

const config = useRuntimeConfig();
const parsedSrc = computed(() => props.src?.replace(IMG_PREFIX, config.public.IMG_CDN_PREFIX) ?? props.src);
</script>

